import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const variantMap = {
  variant: {
    accent: {
      "--background-color": vars.semantic.color.focusAccent,
    },
    critical: {
      "--background-color": vars.semantic.color.iconCritical,
    },
  },
  type: {
    border: {
      "--outline": `var(--border-width) solid ${vars.semantic.color.surface}`,
    },
    default: {
      "--outline": "none",
    },
  },
  size: {
    small: {
      "--border-width": "2px",
      "--width": "6px",
      "--height": "6px",
    },
    medium: {
      "--border-width": "2px",
      "--width": "8px",
      "--height": "8px",
    },
    large: {
      "--border-width": "2px",
      "--width": "10px",
      "--height": "10px",
    },
    largeBold: {
      "--border-width": "3px",
      "--width": "10px",
      "--height": "10px",
    },
  },
} as Record<string, Record<string, Record<string, string>>>;

export const dotBadgeCSS = css({
  display: "inline-block",
  verticalAlign: "middle",

  width: "var(--width)",
  height: "var(--height)",

  backgroundColor: "var(--background-color)",

  borderRadius: vars.rounded.full,

  outline: "var(--outline)",
});
